module.exports = __webpack_public_path__ + "img/read_ticks.1711de40.svg";